module.exports = __webpack_public_path__ + "img/hamburger.ca177b7f.gif";